import { AnchoredContent, Elements, Hero, Breadcrumbs, Credo, Questions, ContentSection, AboutGallery } from "@/components";
import generateBlocks from "@/lib/generateBlocks";
import { StyledContent, StyledTitle, StyledSection } from "@/components/styles";
import addSoftHyphenation from "@/lib/addSoftHyphenation";
import { useEffect, useState } from "react";
import { useRouter } from 'next/router';
import vars from "@/assets/styles/vars";


export default function TextPage(props) {
  const { title, description, blocks, banners, questions, video_card_1, video_card_2, video_card_3, video_card_4, video_logo } = props;

  const breadcrumbs = [
    {
      id: 1,
      title: "Home",
      slug: "",
      type: "index",
    },
    {
      id: 2,
      title: title || "about Us",
      slug: "",
      type: "text-page",
    },
  ];

  const router = useRouter();

  const [thumbnailSwiper, getThumbnailSwiper] = useState(null);
  const [gallerySwiper, getGallerySwiper] = useState(null);

  const thumbnailParams = {
    getSwiper: getThumbnailSwiper,
    direction: "horizontal",
    slidesPerView: "auto",
    spaceBetween: 40,
    watchOverflow: true,
    watchSlidesVisibility: true,
    initialSlide: router.asPath.includes('gallery') ? 7 : 0,
    breakpoints: {
      [vars.breakpoints.tablet + 1]: {
        direction: "vertical",
        spaceBetween: 20,
      },
    },
  };

  const params = {
    slidesPerView: 1,
    getSwiper: getGallerySwiper,
    preloadImages: true,
    resistanceRatio: 0,
    watchOverflow: true,
    keyboard: true,
    speed: 600,
    autoHeight: true,
    spaceBetween: 45,
    initialSlide: router.asPath.includes('gallery') ? 7 : 0,
    noSwipingClass: "no-content-swiping",
    updateOnWindowResize: true,
    allowTouchMove: false,
    breakpoints: {
      [vars.breakpoints.tablet + 1]: {
        spaceBetween: 25,
      },
    },
  };

  const swiperData = { gallerySwiper, thumbnailSwiper, params, thumbnailParams };

  const beforeCards = [...blocks].filter((card) => card.type == "content-before-cards");
  const cardsItems = [...blocks].filter((card) => card.type == "card");
  const credo = [...blocks].filter((card) => card.type == "credo");


  return (
    <>
      {!!banners?.length && <Hero data={banners.map((i) => ({ ...i, link: null }))} />}
      <StyledContent.Container>
        <StyledContent.BreadcrumbsContainer text>{breadcrumbs?.length > 0 && <Breadcrumbs items={breadcrumbs} theme="light" />}</StyledContent.BreadcrumbsContainer>
        <StyledSection pt="none" pb="none">
          <StyledTitle size="large" mb="x-small" as="h1" black center upper tabletLeft>
            {addSoftHyphenation(title, 15)}
          </StyledTitle>
          <StyledContent.Html size="large" center tabletLeft black>
            {description}
          </StyledContent.Html>
        </StyledSection>
      </StyledContent.Container>
      <StyledContent pt="m-large">
        <StyledContent.Container>
          <StyledContent.Columns isAnchorsVisible={true} id="columns">
            <AnchoredContent slider swiperData={swiperData}>
              <StyledSection type="block" title={blocks[0]?.data?.title || title} slug={blocks[0]?.data?.slug || ""} pb="medium">
                {!!beforeCards.length && generateBlocks([...beforeCards.map((i) => ({ ...i, type: "title-content" }))], "large", "small", "x-small")}
                {!!cardsItems.length && (
                  <StyledSection pb="large" pt="none">
                    <Elements data={cardsItems} videos={[video_card_1, video_card_2, video_card_3, video_card_4]} />
                  </StyledSection>
                )}
                {!!credo.length && (
                  <StyledSection pt="none" pb="none">
                    <StyledContent.Credo>
                      {credo.map((item, ind) => (
                        <Credo key={ind} data={item.data} video={video_logo} />
                      ))}
                    </StyledContent.Credo>
                  </StyledSection>
                )}
              </StyledSection>
              {!!blocks?.length && generateBlocks(blocks, "large", "small", "small", swiperData)}

              {!!questions?.length && (
                <ContentSection pt="none" type="questions">
                  <Questions data={questions} swiperData={swiperData} />
                </ContentSection>
              )}
              {!!credo.length && (<ContentSection pt="none" type="gallery" title="Gallery">
                <AboutGallery swiperData={swiperData} />
              </ContentSection>)}
            </AnchoredContent>
          </StyledContent.Columns>
        </StyledContent.Container>
      </StyledContent>
    </>
  );
}
